// src/core/widgets/hooks.ts
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
    getWidgets,
    createWidget,
    updateWidget,
    deleteWidget,
} from "./api";

// 🔹 Query Keys
export const widgetsKeys = {
    root: ["widgets"] as const,
    list: () => [...widgetsKeys.root, "list"] as const,
};

// 🔹 Fetch widgets list
export function useWidgets() {
    return useQuery({
        queryKey: widgetsKeys.list(),
        queryFn: getWidgets,
        select: (res) => res, 
        staleTime: 60_000,
    });
}

// 🔹 Create widget
export function useCreateWidget() {
    const _qc = useQueryClient();
    return useMutation({
        mutationFn: (body: any) => createWidget(body),
    });
}

// 🔹 Update widget
export function useUpdateWidget() {
    const _qc = useQueryClient();
    return useMutation({
        mutationFn: ({ body, id }: { body: any; id: string }) => updateWidget(body, id),
    });
}

// 🔹 Delete widget
export function useDeleteWidget() {
    const _qc = useQueryClient();
    return useMutation({
        mutationFn: (id: string) => deleteWidget(id),
    });
}
